
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSOrderLaborGrid extends Serenity.EntityGrid<POSOrderLaborRow, any> {
        protected getColumnsKey() { return 'Retail.OrderLabor'; }
        protected getIdProperty() { return POSOrderLaborRow.idProperty; }
        protected getInsertPermission() { return POSOrderLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return POSOrderLaborRow.localTextPrefix; }
        protected getService() { return POSOrderLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}